import { render, staticRenderFns } from "./ArticleExpirer.vue?vue&type=template&id=6652047f&"
import script from "./ArticleExpirer.vue?vue&type=script&lang=js&"
export * from "./ArticleExpirer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports